<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
    <g clip-path="url(#clip0_29224_22197)">
      <path
        d="M96.875 3.125L37.5 46.875"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M28.125 9.375H40.625" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M34.375 3.125V15.625" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.25 34.375H25" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.625 25V43.75" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M77.7125 96.8745C76.7 89.9203 75.8417 81.6453 75.375 71.9995"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.6187 71.9995C24.1521 81.6453 23.2938 89.9162 22.2812 96.8745"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M71.875 39.6626C86.7417 42.8084 96.875 49.0543 96.875 56.2501C96.875 66.6043 75.8875 75.0001 50 75.0001C24.1125 75.0001 3.125 66.6043 3.125 56.2501C3.12875 55.1753 3.34985 54.1123 3.775 53.1251"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.125 50.0366C67.1875 50.3825 78.125 53.0325 78.125 56.2491C78.125 59.6991 65.5333 62.4991 50 62.4991C34.4667 62.4991 21.875 59.6991 21.875 56.2491"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_29224_22197">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  height: 100px;
}
</style>
